import React from "react";
import ModalCheckCV from "./ModalCheckCV";
import moment from "moment";

const index = ({
  isModalOpenCheckCV,
  setIsModalOpenCheckCV,
  dataCheckCV,

}) => {
  const handleCancelCheckCV = () => {
    setIsModalOpenCheckCV(false);
  };

  const columns = [
    {
      title: "STT",
      dataIndex: "index",
      key: "index",
      align: "center",
      className: "vertical-middle",
      width: 80,
      render: (value, item, index) =>index + 1,
      fixed: 'left',
    },
    {
      title: "Tiêu Đề YCTD",
      dataIndex: "code_cv",
      key: "code_cv",
      filterKey: "code_cv",
      className: "highlight vertical-middle",
      type: "text",
      canSearch: true,
      align: "center",
      width: 100,
      fixed: 'left',
    },
    {
      title: "Mã Yêu Cầu",
      dataIndex: "ticket_code",
      key: "ticket_code",
      filterKey: "ticket_code",
      className: "highlight vertical-middle",
      type: "text",
      canSearch: true,
      align: "center",
      width: 100,
      // render: (value, item, index) => (
      //   <a href={"/cv/" + value} target="_blank">
      //     {value}
      //   </a>
      // ),
    },
    {
      title: "Số Điện Thoại",
      dataIndex: "numberphone",
      key: "numberphone",
      className: "vertical-middle",
      align: "center",
      width: 100,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      className: "vertical-middle",
      align: "center",
    },
    {
      title: "Họ Và Tên",
      dataIndex: "name",
      key: "name",
      className: "vertical-middle",
      align: "center",
      render: (_, record) => (
        <span>
          {record.last_name != null
            ? record.last_name + " " + record.first_name
            : record.first_name}
        </span>
      ),
    },
    {
      title: "Ngày Sinh",
      dataIndex: "birthday",
      key: "birthday",
      className: "vertical-middle",
      align: "center",
      width: 100,
      render: (value, item, index) =>
        moment(value, "YYYY-MM-DD").format("DD/MM/YYYY"),
    },

    {
      title: "Trạng Thái CV",
      dataIndex: "cv_status_name",
      key: "cv_status_name",
      className: "vertical-middle",
      align: "center",
      render: (value, item) => (
        <span
          className="btnStatus"
          style={{
            backgroundColor: item.color,
          }}
        >
          {value}
        </span>
      ),
    },
    {
      title: "Ngày Tạo",
      dataIndex: "created",
      key: "created",
      className: "vertical-middle",
      align: "center",
      width: 100,
      render: (value, item, index) =>
        moment(value).format("DD/MM/YYYY HH:mm:ss"),
    },
  ];

  return (
    <ModalCheckCV
      isModalOpenCheckCV={isModalOpenCheckCV}
      dataCheckCV={dataCheckCV}
      handleCancelCheckCV={handleCancelCheckCV}
      columns={columns}
    />
  );
};

export default index;
